// Экраны вне основного сценария: загрузка, запуск вне MAX, ошибка входа.
import { Button, Spinner, Typography } from '@maxhub/max-ui';

import { useAuth } from '@/auth/context';

function Gate({
  title,
  text,
  action,
  actionLabel = 'Попробовать снова',
}: {
  title: string;
  text: string;
  action?: () => void;
  actionLabel?: string;
}) {
  return (
    <div className="screen">
      <div className="center-state">
        <Typography.Text variant="header">{title}</Typography.Text>
        <Typography.Text variant="body" color="secondary" role="alert">
          {text}
        </Typography.Text>
        {action ? (
          <Button size="large" onClick={action}>
            {actionLabel}
          </Button>
        ) : null}
      </div>
    </div>
  );
}

export function GatePage() {
  const { status, error, retry } = useAuth();
  if (status === 'loading') {
    return (
      <div className="screen">
        <div className="center-state" role="status">
          <Spinner size={32} appearance="themed" />
          <Typography.Text variant="detail" color="secondary">
            Входим…
          </Typography.Text>
        </div>
      </div>
    );
  }
  if (status === 'signed_out') {
    return (
      <Gate title="Вы вышли" text="Документы сохранены." action={retry} actionLabel="Войти снова" />
    );
  }
  if (status === 'outside') {
    return (
      <Gate
        title="Откройте в MAX"
        text={
          // Подсказка про dev-вход нужна разработчику, а не человеку со ссылкой.
          import.meta.env.DEV
            ? 'Для входа в браузере задайте VITE_DEV_INIT_DATA (cd core && uv run python -m core.scripts.dev_init_data).'
            : 'Откройте приложение из чата с ботом.'
        }
      />
    );
  }
  return <Gate title="Не удалось войти" text={error ?? 'Сервер недоступен'} action={retry} />;
}
